import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  private messaging: any;

  private async initFirebaseMessaging(): Promise<any> {
    if (this.messaging) {
      return this.messaging;
    }

    const [{ initializeApp }, { getMessaging }] = await Promise.all([
      import('firebase/app'),
      import('firebase/messaging')
    ]);

    const app = initializeApp(environment.firebase);
    this.messaging = getMessaging(app);
    return this.messaging;
  }

  async requestPermissionAndGetToken(): Promise<string | null> {
    try {
      if (!("Notification" in window)) {
        console.error("Notifications are not supported.");
        return null;
      }

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.error('Permission not granted');
        return null;
      }

      // ✅ get existing registration instead of always registering
      let registration = await navigator.serviceWorker.getRegistration(
        '/firebase-messaging-sw.js'
      );

      if (!registration) {
        registration = await navigator.serviceWorker.register(
          '/firebase-messaging-sw.js'
        );
      }

      const { getToken } = await import('firebase/messaging');
      await this.initFirebaseMessaging();
      const token = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapId,
        serviceWorkerRegistration: registration
      });

      // console.log('FCM WEB TOKEN:', token);
      return token;

    } catch (error) {
      console.error('Error in token generation:', error);
      return null;
    }
  }
}